export default (params) => ({
  trigger: {
    name: 'content_blocks.article_list.view',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'one_list',
          'two_lists',
          'three_lists',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'view_content',
      params: {
        content: null,
      },
    },
    nonInt: true,
  },
});
